import { useUpdateEffect } from '@cian/react-utils';

import { useEffect, useState } from 'react';

import { boundActionsFactory } from '@/packages/redux-state/store';

import { useMapInitialOptions } from './useMapInitialOptions';
import { useMapInitialState } from './useMapInitialState';

interface IUseInitMapParams {
  mapRef: React.RefObject<HTMLDivElement>;
  ymaps: YMaps.IYMaps | null;
}

const useBoundActions = boundActionsFactory(reduxActions => ({
  setMapConfiguration: reduxActions.mapConfiguration.setMapConfiguration,
  setMapInitialized: reduxActions.mapConfiguration.setMapInitialized,
}));

export const useInitMap = (params: IUseInitMapParams): YMaps.Map | null => {
  const { mapRef, ymaps } = params;

  const [map, setMap] = useState<YMaps.Map | null>(null);

  const state = useMapInitialState(params);

  const options = useMapInitialOptions();

  const actions = useBoundActions();

  useEffect(() => {
    const mapElement = mapRef.current;

    if (!ymaps || !mapElement || !state) {
      return;
    }

    const mapInstance = new ymaps.Map(mapElement, state, options);

    actions.setMapConfiguration({
      bounds: mapInstance.getBounds(),
      center: mapInstance.getCenter(),
      zoom: mapInstance.getZoom(),
    });

    setMap(mapInstance);
  }, [options, setMap, state, mapRef, ymaps, actions]);

  useUpdateEffect(() => {
    actions.setMapInitialized();
  }, [map]);

  return map;
};
